import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DiseaseRoutingModule } from './disease-routing.module';
import { DiseaseComponent } from './disease/disease.component';
import { BsDatepickerModule, DatepickerModule } from 'ngx-bootstrap';
import { ChartModule } from '@kiwigrid/ngx-highcharts';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule } from '@angular/forms';
import { TourMatMenuModule } from 'ngx-tour-md-menu';
import { LayoutComponentsModule } from 'src/app/shared/modules/layout-components.module';

@NgModule({
    imports: [
        CommonModule,
        DiseaseRoutingModule,
        FormsModule,
        BsDatepickerModule,
        DatepickerModule,
        ChartModule,
        NgxDatatableModule,
        TourMatMenuModule,
        LayoutComponentsModule
    ],
    declarations: [
        DiseaseComponent
    ]
})
export class DiseaseModule { }
